<mat-card class="example-card">
  <mat-card-header class="py-8 bg-blue-900 text-white flex rounded-t-md">
    <div class="font-bold text-3xl">Tarifs</div>
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->

    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>

    <div class="flex items-center justify-between">
      <div class="flex item-center justify-start">
        <mat-form-field appearance="outline">
          <mat-label>Du</mat-label>
          <input matInput [matDatepicker]="dateDebut" placeholder="Du" [(ngModel)]="date_Debut" />
          <mat-datepicker-toggle matSuffix [for]="dateDebut"></mat-datepicker-toggle>
          <mat-datepicker #dateDebut></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Au</mat-label>
          <input matInput [matDatepicker]="dateFin" placeholder="Au" [(ngModel)]="date_Fin" />
          <mat-datepicker-toggle matSuffix [for]="dateFin"></mat-datepicker-toggle>
          <mat-datepicker #dateFin></mat-datepicker>
        </mat-form-field>

        <app-recherche #fournisseurComponent [style]="{ width: '170px', 'margin-right': '10px' }"
          [api]="generalService.api" [numColonneToShow]="1" [numColonneToReturn]="0"
          (ChampEnter)="blurFournisseur($event)" [ngModel]="Tiers_RS" recherche="batfour1" name="fournisseur"
          placeholder="FOURNISSEUR">
        </app-recherche>

        <button [disabled]="!exist" (click)="getListeTarifReservation()" mat-raised-button class="colorGreen my-8">
          <mat-icon>search</mat-icon>
          Filtrer
        </button>

        <button [disabled]="listeTarifs.length == 0" (click)="miseAjourTarifs()" mat-raised-button
          class="bg-blue-800 my-8 text-white mx-2 ml-32">
          <mat-icon>update</mat-icon>
          MAJ Tarifs
        </button>

        <mat-form-field *ngIf="listeTarifs.length != 0" appearance="outline" style="width: 150px" class="mx-2">
          <mat-label>Marge Tarif</mat-label>
          <input type="number" min="0" matInput name="Tarif" [(ngModel)]="MargeTarif" placeholder="Marge Tarif (dt)" />
        </mat-form-field>
      </div>

      <div>
        <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none"
          accept=".csv, .txt, .xlsx" />

        <button
          class="flex items-center justify-center px-5 py-2 font-semibold text-lg text-gray-800 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto hover:bg-gray-100"
          (click)="openFileSelection()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3098_154395)">
              <path
                d="M13.3333 13.3332L9.99997 9.9999M9.99997 9.9999L6.66663 13.3332M9.99997 9.9999V17.4999M16.9916 15.3249C17.8044 14.8818 18.4465 14.1806 18.8165 13.3321C19.1866 12.4835 19.2635 11.5359 19.0351 10.6388C18.8068 9.7417 18.2862 8.94616 17.5555 8.37778C16.8248 7.80939 15.9257 7.50052 15 7.4999H13.95C13.6977 6.52427 13.2276 5.61852 12.5749 4.85073C11.9222 4.08295 11.104 3.47311 10.1817 3.06708C9.25943 2.66104 8.25709 2.46937 7.25006 2.50647C6.24304 2.54358 5.25752 2.80849 4.36761 3.28129C3.47771 3.7541 2.70656 4.42249 2.11215 5.23622C1.51774 6.04996 1.11554 6.98785 0.935783 7.9794C0.756025 8.97095 0.803388 9.99035 1.07431 10.961C1.34523 11.9316 1.83267 12.8281 2.49997 13.5832"
                stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_3098_154395">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Import Fichier Tarifs</span>
        </button>
      </div>
    </div>

    <br />
    <app-liste *ngIf="columnsReservation" [listBtn]="listBtn" #listeConmponent [showFilter]="true" [showSort]="true"
      [showHeader]="true" [maxHeight]="200" [titre]="'<h4><b>Tarifs trouvées</b></h4>'" [dataSource]="listeTarifs"
      [columns]="columnsReservation" (output)="output($event)">
    </app-liste>
    <br />
    <!-- <div  *ngIf="listeConmponent && listeConmponent.row && columnsReservationDetail">
                      <app-liste 
                          #listeDetailConmponent
                          [showFilter]="true"
                          [showSort]="true"
                          [titre]="'<h4><b>Détail réservation</b></h4>'"
                          [dataSource]="listeTarifsDetail" 
                          [columns]="columnsReservationDetail">
                      </app-liste>  
                  </div>     -->
  </mat-card-content>
</mat-card>

<ng-template #frmAjout>
  <div class="display-flex-end mb-20 gap-4">
    <button mat-raised-button class="colorGreen" (click)="ajouterOuModifierLigneTarif()">
      <mat-icon>done</mat-icon>
      Enregistrer
    </button>

    <button (click)="close()" mat-raised-button class="bg-red-600 text-white">
      <mat-icon>close</mat-icon>
      Fermer
    </button>
  </div>
  <div class="display-flex-start mb-20 gap-4 space-x-10">
    <mat-slide-toggle [(ngModel)]="isValid" [disabled]="disableBtnValidTarif">Tarif : {{ isValid ? "valide" : "invalide"
      }}</mat-slide-toggle>

    <span class="bg-sky-700 text-white px-3 py-1 rounded font-semibold"
      [class]="this.TravelTarif?.Tarif_MAJ != 1 ? 'bg-pink-700' : 'bg-blue-700'">
      {{
      this.TravelTarif?.Tarif_MAJ != 1
      ? "Mise à jour manuelle"
      : "Mise à jour automatique"
      }}
    </span>
  </div>

  <div class="flex flex-row">
    <div>
      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>Code Tarif</mat-label>
        <input type="text" matInput name="Tarif_Code" [(ngModel)]="TravelTarif.Tarif_Code" placeholder="Code Tarif" />
      </mat-form-field>
      <app-recherche #fournisseurComponent [style]="{ width: '170px', 'margin-right': '10px' }"
        [api]="generalService.api" [numColonneToShow]="1" [numColonneToReturn]="0"
        (ChampEnter)="blurFournisseur($event)" recherche="batfour1" name="fournisseur" placeholder="FOURNISSEUR"
        [ngModel]="Tiers_RS">
      </app-recherche>

      <app-recherche [style]="{ width: '170px', 'margin-right': '10px' }" [api]="generalService.api"
        [numColonneToShow]="0" [numColonneToReturn]="1" (lineSelected)="blurTypeTarif($event)"
        recherche="API_Listetype1" [param]="Tiers_Code" name="typeTarif" placeholder="Type Tarif"
        [ngModel]="Tarif_Text">
      </app-recherche>

      <mat-form-field appearance="outline" class="width-150 mx-2">
        <mat-label>IND_COLL</mat-label>
        <mat-select name="IND_COLL" [(ngModel)]="TravelTarif.IND_COLL" placeholder="IND_COLL">
          <mat-option *ngFor="let t of listIndColl" [value]="t">{{ t }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>Groupe Min</mat-label>
        <input type="number" min="0" matInput name="Groupe_Min" [(ngModel)]="TravelTarif.Groupe_Min"
          placeholder="Groupe Min" />
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>Groupe Max</mat-label>
        <input type="number" min="0" matInput name="Groupe_Max" [(ngModel)]="TravelTarif.Groupe_Max"
          placeholder="Groupe Max" />
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>Accompagnant</mat-label>
        <input type="number" min="0" max="1" matInput name="accompagnant" [(ngModel)]="TravelTarif.Accompagnant"
          placeholder="Accompagnant" />
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>Chauffeur</mat-label>
        <input type="number" min="0" max="1" matInput name="chauffeur" [(ngModel)]="TravelTarif.Chauffeur"
          placeholder="Chauffeur" />
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>Guide</mat-label>
        <input type="number" min="0" max="1" matInput name="guide" [(ngModel)]="TravelTarif.Guide"
          placeholder="Guide" />
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>TVA</mat-label>
        <input type="number" min="0" max="100" matInput name="TVA" [(ngModel)]="TravelTarif.TVA" placeholder="TVA" />
        <mat-hint align="end">{{ TravelTarif.TVA * 100}}%</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100px" class="mx-2">
        <mat-label>Marge</mat-label>
        <input type="number" min="0" max="100" matInput name="Marge" [(ngModel)]="TravelTarif.Marge"
          placeholder="Marge" />
        <mat-hint align="end">{{ TravelTarif.Marge * 100 }}%</mat-hint>
      </mat-form-field>
    </div>

    <div class="ml-12" style="border-left: 1px solid #000; height: auto; margin-right: 10px"></div>

    <div>
      <unilog-date-picker [label]="'Date arrivée'" style="width: 50%" [(date)]="TravelTarif.Date_Deb">
      </unilog-date-picker>
      <unilog-date-picker [label]="'Date départ'" class="w-36" [(date)]="TravelTarif.Date_Fin">
      </unilog-date-picker>
      <!-- <mat-form-field appearance="outline" style="font-weight: bold">
        <mat-label>Du</mat-label>
        <input
          matInput
          [matDatepicker]="dateDebut"
          placeholder="Du"
          [(ngModel)]="TravelTarif.Date_Deb"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateDebut"
        ></mat-datepicker-toggle>
        <mat-datepicker #dateDebut></mat-datepicker>
      </mat-form-field> -->
      <!-- 
      <mat-form-field appearance="outline" style="font-weight: bold">
        <mat-label>Au</mat-label>
        <input
          matInput
          [matDatepicker]="dateFin"
          placeholder="Au"
          [(ngModel)]="TravelTarif.Date_Fin"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateFin"
        ></mat-datepicker-toggle>
        <mat-datepicker #dateFin></mat-datepicker>
      </mat-form-field> -->

      <mat-form-field appearance="outline" style="width: 270px; font-weight: bold; font-size: 25px" class="mx-2">
        <mat-label style="
            font-weight: bold;
            font-size: 25px;
            margin-left: 5.8rem;
            padding-right: 17px;
          ">Tarif</mat-label>
        <input type="number" min="0" matInput name="Tarif" [(ngModel)]="TravelTarif.Tarif" placeholder="Tarif" />
      </mat-form-field>
      <br />
      <!-- <mat-form-field appearance="outline" style="width: 270px" class="mx-2">
                        <mat-label>Marge</mat-label>
                        <input type="number" min="0" matInput name="marge" [(ngModel)]="TravelTarif.Marge"
                          placeholder="Marge" />
                      </mat-form-field> -->
    </div>
  </div>

  <div class="flex flex-row w-full">
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>OBSERVATION</mat-label>
      <textarea matInput [(ngModel)]="TravelTarif.Observation"></textarea>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #frmPreviewMAJtarif>
  <div class="display-flex mb-20 gap-4">
    <div class="text-2xl font-bold inline-block">
      <span class="text-gray-800"> Aperçu </span>
    </div>

    <div class="gap-4">
      <button mat-raised-button class="colorGreen" (click)="postBloqueTarifs()">
        <mat-icon>done</mat-icon>
        Enregistrer
      </button>
      <button (click)="close()" mat-raised-button class="bg-red-600 text-white">
        <mat-icon>close</mat-icon>
        Fermer
      </button>
    </div>
  </div>

  <div class="flex flex-row">
    <div class="shadow rounded border-b border-gray-200">
      <table class="w-full bg-white">
        <thead class="bg-gray-800 text-white">
          <tr>
            <th *ngFor="let column of columnsTarifApercu" class="text-center py-3 px-8 uppercase font-semibold text-xs">
              {{ column.TableRD_Des }}
            </th>
          </tr>
        </thead>
        <tbody class="text-gray-700">
          <ng-container *ngFor="let item of listeTarifsPreview; index as i">
            <tr [class]="i % 2 == 0 ? 'bg-gray-100' : ''">
              <td class="text-center py-3 px-8">
                {{ item.Tiers_code }}
              </td>
              <td class="text-center">
                {{ item.Valide }}
              </td>
              <!-- <td class="text-center py-3 px-8">
                <input
                  id="Type_Tarif"
                  type="number"
                  [(ngModel)]="item.Type_Tarif"
                  [value]="item.Type_Tarif"
                  class="rounded-md border text-center p-4"
                  style="width: 100px"
                />
              </td>
              <td class="text-center py-3 px-8">
                <select
                  id="Type_Tarif"
                  type="number"
                  [(ngModel)]="item.Type_Tarif"
                  [value]="item.Type_Tarif"
                  class="rounded-md border text-center p-4"
                  style="width: 100px"
                >
                <option value=""></option>
                </select>
              </td> -->
              <td class="text-center py-3 px-8">
                {{ item.Type_Tarif }}
              </td>

              <td class="text-center">
                {{ item.IND_COLL }}
              </td>

              <td class="text-center font-bold text-red-600 py-3 px-8">
                <input id="tarif" type="number" [(ngModel)]="item.Tarif" class="rounded-md border text-center p-4"
                  style="width: 100px" />
              </td>

              <td class="text-center py-3 px-8">
                <input id="Observation" type="text" [(ngModel)]="item.Observation"
                  class="rounded-md border text-center p-4" style="width: 100px" />
              </td>

              <td class="text-center font-bold text-red-600 py-3 px-8">
                <mat-form-field appearance="outline">
                  <input matInput [matDatepicker]="Date_Deb" [(ngModel)]="item.Date_Deb" />
                  <mat-datepicker-toggle matSuffix [for]="Date_Deb"></mat-datepicker-toggle>
                  <mat-datepicker #Date_Deb></mat-datepicker>
                </mat-form-field>
              </td>
              <td class="text-center font-bold text-red-600 py-3 px-8">
                <mat-form-field appearance="outline">
                  <input matInput [matDatepicker]="Date_Fin" [(ngModel)]="item.Date_Fin" />
                  <mat-datepicker-toggle matSuffix [for]="Date_Fin"></mat-datepicker-toggle>
                  <mat-datepicker #Date_Fin></mat-datepicker>
                </mat-form-field>
              </td>
              <td class="text-center py-3 px-8">
                <input id="Groupe_Min" type="number" [(ngModel)]="item.Groupe_Min"
                  class="rounded-md border text-center p-4" style="width: 100px" />
              </td>
              <td class="text-center py-3 px-8">
                <input id="Groupe_Max" type="number" [(ngModel)]="item.Groupe_Max"
                  class="rounded-md border text-center p-4" style="width: 100px" />
              </td>
              <td class="text-center py-3 px-8">
                <input id="Accompagnant" type="number" [(ngModel)]="item.Accompagnant"
                  class="rounded-md border text-center p-4" style="width: 100px" />
              </td>
              <td class="text-center py-3 px-8">
                <input id="Chauffeur" type="number" [(ngModel)]="item.Chauffeur"
                  class="rounded-md border text-center p-4" style="width: 100px" />
              </td>
              <td class="text-center py-3 px-8">
                <input id="Guide" type="number" [(ngModel)]="item.Guide" class="rounded-md border text-center p-4"
                  style="width: 100px" />
              </td>
              <td class="text-center py-3 px-8">
                <input id="TVA" type="number" [(ngModel)]="item.TVA" class="rounded-md border text-center p-4"
                  style="width: 100px" />
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!listeTarifs || listeTarifs.length == 0">
            <td colspan="6" class="text-center text-2xl font-bold py-3 px-16">
              pas de données disponnibles
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #frmPreviewImportTarifs>
  <div class="display-flex mb-20 gap-4">
    <div class="text-2xl font-bold inline-block">
      <span class="text-gray-800"> Aperçu </span>
    </div>

    <div class="gap-4">
      <button mat-raised-button class="colorGreen" (click)="MultiPostTarifs(ListImportedTarifs)">
        <mat-icon>done</mat-icon>
        Enregistrer
      </button>
      <button (click)="close()" mat-raised-button class="bg-red-600 text-white">
        <mat-icon>close</mat-icon>
        Fermer
      </button>
    </div>
  </div>

  <div class="flex flex-row">
    <div class="shadow rounded border-b border-gray-200">
      <div *ngIf="ListImportedTarifs && ListImportedTarifs.length">
        <table class="w-full bg-white">
          <thead class="bg-gray-800 text-white">
            <tr>
              <th class="text-center py-3 px-8 uppercase font-semibold text-xs" *ngFor="let key of tableHeaders">
                {{ key }}
              </th>
              <th class="text-center py-3 px-8 uppercase font-semibold text-xs">
                Action
              </th>
            </tr>
          </thead>
          <tbody class="text-gray-700">
            <tr *ngFor="let row of ListImportedTarifs; index as i" [class]="i % 2 == 0 ? 'bg-gray-100' : ''">
              <td class="text-center py-3 px-8" *ngFor="let key of tableHeaders">
                {{ row[key] }}
              </td>
              <td class="text-center py-3 px-8">
                <button (click)="removeItemFromImportedList(row)" mat-raised-button class="bg-red-600 text-white">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #frmDupliquate>
  <div class="display-flex mb-20 gap-4">
    <div class="text-2xl font-bold inline-block">
      <span class="text-gray-800"> Mise à jour Tarif </span>
    </div>

    <div class="gap-4">
      <button (click)="onPostDupliquateTarif()" mat-raised-button class="colorGreen mx-2">
        <mat-icon>done</mat-icon>
        Enregistrer
      </button>
      <button (click)="close()" mat-raised-button class="bg-red-600 mx-2 text-white">
        <mat-icon>close</mat-icon>
        Fermer
      </button>
    </div>
  </div>
  <div class="flex flex-col w-full justify-center">
    <mat-form-field appearance="outline" style="width: 100%; font-weight: bold; font-size: 25px" class="mx-2">
      <mat-label style="
          font-weight: bold;
          font-size: 25px;

          padding-right: 17px;
          padding-left: 17px;
        ">Ancienne Tarif</mat-label>
      <input type="number" min="0" matInput name="Tarif" [(ngModel)]="oldTarif.TravelTarif[0].Tarif"
        placeholder="Ancienne Tarif" [readonly]="true" class="strike-through" />
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%; font-weight: bold; font-size: 25px" class="mx-2">
      <mat-label style="
          font-weight: bold;
          font-size: 25px;

          padding-right: 17px;
          padding-left: 17px;
        ">Nouvelle Tarif</mat-label>
      <input type="number" min="0" matInput name="Tarif" [(ngModel)]="copyTarif.TravelTarif[0].Tarif"
        placeholder="Nouvelle Tarif" />
    </mat-form-field>
  </div>
</ng-template>